import {addClass, getCookie, makeElement, removeClass, setCookie} from '../common/Utils';
import {checkCookie} from './checkCookie';
/**
 * 토스트 배너
 * 서브페이지에서만 노출
 * 단, 플로팅 배너가 활성화 되어 있으면 노출 하지 않음
 * 닫기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */

class ToastLayer {
    constructor(_isMain= false, _isLauncher = false, _data = {}) {
        this.isCookieApply = checkCookie();
        // console.log( '=> ToastLayer.js constructor: checkCookie() : ', checkCookie() , this.isCookieApply);

        let thisIsCookieApply = this.isCookieApply && getCookie(_data.toastCookie);

        if( _isMain || !_data.showToastBanner || thisIsCookieApply || _data.showFloatingBanner){
            return false;
        }

        if ( _isLauncher && !_data.toastLauncherShow ) {
            return false;
        }

        this.bannerEl = this.template( _data ) ;

        document.body.appendChild( this.bannerEl );
        this.addEvents(_data);

        setTimeout(()=> {
            addClass( this.bannerEl , 'is-show');
        }, 1000);

    }


    template(_data){
        this.el = makeElement( `

            <div class="nc-banner" data-type="toast">
             ${_data.toastLink != ''?`
                 <a href="${_data.toastLink}" ${_data.toastLinkNewWindow ? 'target=_blank' :''} class="nc-banner-link" style="background-image:url('${_data.toastBG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.toastLable}</div>
                        <strong class="nc-banner-title-main">${_data.toastTitle}</strong>
                        <em class="nc-banner-title-sub">${_data.toastSubTitle}</em>
                    </div>
                </a>
            ` : `
               <span class="nc-banner-link" style="background-image:url('${_data.toastBG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.toastLable}</div>
                        <strong class="nc-banner-title-main">${_data.toastTitle}</strong>
                        <em class="nc-banner-title-sub">${_data.toastSubTitle}</em>
                    </div>
                </span>
            `}


                <button class="nc-banner-close"><span class="blind">그만보기</span></button>
            </div>
        ` );

        return this.el;
    }


    addEvents(_data){
        document.querySelector(".nc-banner[data-type=toast] .nc-banner-close").addEventListener('click', e =>{

            // console.log( '=> ToastLayer.js constructor: this.isCookieApply : ', this.isCookieApply  );
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.toastCookie, true, 100, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.toastCookie, true, 100, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.toastCookie, true, 100, '.plaync.com');
            }
            removeClass( document.querySelector(".nc-banner[data-type=toast]"), 'is-show');
        });
    }

}
export default ToastLayer;